import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const primaryNavItems = [
    { label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    { label: 'Portfolio', path: '/credit-portfolio', icon: 'Briefcase' },
    { label: 'Claims', path: '/claims-builder', icon: 'FileText' },
    { label: 'Compliance', path: '/article-6-gateway', icon: 'Shield' },
    { label: 'Intelligence', path: '/methodology-intelligence', icon: 'Brain' }
  ];

  const secondaryNavItems = [
    { label: 'Registry Connectors', path: '/registry-connectors', icon: 'Link' },
    { label: 'Provenance Tracking', path: '/provenance-tracking', icon: 'GitBranch' }
  ];

  const currentPath = window.location?.pathname;

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  const toggleMoreMenu = () => {
    setIsMoreMenuOpen(!isMoreMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-100 bg-background border-b border-border shadow-subtle">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo Section */}
        <div className="flex items-center">
          <button 
            onClick={() => handleNavigation('/dashboard')}
            className="flex items-center space-x-3 hover:opacity-80 transition-smooth"
          >
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Leaf" size={20} color="white" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-semibold text-foreground leading-tight">
                Carbon Integrity
              </span>
              <span className="text-xs text-muted-foreground leading-tight">
                Router
              </span>
            </div>
          </button>
        </div>

        {/* Primary Navigation */}
        <nav className="hidden lg:flex items-center space-x-1">
          {primaryNavItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-smooth ${
                currentPath === item?.path
                  ? 'bg-primary text-primary-foreground'
                  : 'text-foreground hover:bg-muted hover:text-foreground'
              }`}
            >
              <Icon name={item?.icon} size={16} />
              <span>{item?.label}</span>
            </button>
          ))}
          
          {/* More Menu */}
          <div className="relative">
            <button
              onClick={toggleMoreMenu}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-smooth ${
                secondaryNavItems?.some(item => currentPath === item?.path)
                  ? 'bg-primary text-primary-foreground'
                  : 'text-foreground hover:bg-muted hover:text-foreground'
              }`}
            >
              <Icon name="MoreHorizontal" size={16} />
              <span>More</span>
            </button>
            
            {isMoreMenuOpen && (
              <div className="absolute top-full right-0 mt-2 w-56 bg-popover border border-border rounded-lg shadow-subtle z-200">
                <div className="py-2">
                  {secondaryNavItems?.map((item) => (
                    <button
                      key={item?.path}
                      onClick={() => {
                        handleNavigation(item?.path);
                        setIsMoreMenuOpen(false);
                      }}
                      className={`w-full flex items-center space-x-3 px-4 py-2 text-sm transition-smooth ${
                        currentPath === item?.path
                          ? 'bg-accent text-accent-foreground'
                          : 'text-popover-foreground hover:bg-muted'
                      }`}
                    >
                      <Icon name={item?.icon} size={16} />
                      <span>{item?.label}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
        </nav>

        {/* Right Section */}
        <div className="flex items-center space-x-4">
          {/* Status Indicator */}
          <div className="hidden md:flex items-center space-x-2 px-3 py-1 bg-success/10 rounded-full">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
            <span className="text-xs font-medium text-success">All Systems Operational</span>
          </div>

          {/* User Context Panel */}
          <div className="flex items-center space-x-3">
            <div className="hidden md:block text-right">
              <div className="text-sm font-medium text-foreground">Global Carbon Corp</div>
              <div className="text-xs text-muted-foreground">Portfolio: 2.4M tCO2e</div>
            </div>
            <button className="w-8 h-8 bg-muted rounded-full flex items-center justify-center hover:bg-muted/80 transition-smooth">
              <Icon name="User" size={16} />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 hover:bg-muted rounded-lg transition-smooth">
            <Icon name="Menu" size={20} />
          </button>
        </div>
      </div>
      {/* Mobile Navigation Overlay */}
      <div className="lg:hidden fixed inset-0 top-16 bg-background z-300 hidden">
        <nav className="p-6 space-y-4">
          {[...primaryNavItems, ...secondaryNavItems]?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg text-left transition-smooth ${
                currentPath === item?.path
                  ? 'bg-primary text-primary-foreground'
                  : 'text-foreground hover:bg-muted'
              }`}
            >
              <Icon name={item?.icon} size={20} />
              <span className="font-medium">{item?.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;